import { DATALAKE_CONSULTA_DADOS_PATH } from "src/utils/api-routes"
import { CALCULO } from "src/utils/constants"
import ParameterCalcIRTable from "./tables/parameter-calc-ir-table"
import ParameterFaixaDurationTable from "./tables/parameter-calc-faixa-duration-table"
import ParameterGrupoAtivoTable from "./tables/parameter-calc-grupo-ativo-table"
import ParameterGrupoIndicadorTable from "./tables/parameter-calc-grupo-indicador-table"
import ParameterSetorialTable from "./tables/parameter-calc-setorial-table"
import ParameterIDCurvasTable from "./tables/parameter-calc-id-curvas"
import ParameterMultiplicadorLiquidezTable from "./tables/parameter-calc-multiplicador-liquidez-table"
import ParameterRegrasDurasOutliersTable from "./tables/parameter-calc-regras-duras-outliers-table"
import ParameterRegrasDurasVolatilidadeTable from "./tables/parameter-calc-regras-duras-volatilidade-table"
import ParameterAliasIndicadoresTable from "./tables/parameter-calc-alias-indicadores-table"
import ParameterCriteriosLiquidezTable from "./tables/parameter-calc-criterios-liquidez-table"
import ParameterScoreRatingTable from "./tables/parameter-calc-score-rating-table"
import ParameterCurvasNssInical from "./tables/parameter-calc-curvas-inss-inical-table"
import ParameterCalcSpreadsIndicativosOverlayTable from "./tables/parameter-calc-spreads-indicativos-overlay"
import ParameterCalcSpreadsDevedorOverlayTable from "./tables/parameter-calc-spreads-devedor-overlay"
import ParameterCalcSpreadsSecPulverizadoOverlayTable from "./tables/parameter-calc-spreads-sec-pulverizado-overlay"
import ParameterCalcEventosCreditoClassificacaoTable from "./tables/parameter-calc-eventos-credito-classificacao"

export const parameterCalcTableList = [
    {
        key: "Calc_AliquotaIR",
        label: "Calc_AliquotaIR",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCalcIRTable,
        app: CALCULO,
        model: "AliquotaIR",
    },
    {
        key: "Calc_FaixaDuration",
        label: "Calc_FaixaDuration",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterFaixaDurationTable,
        app: CALCULO,
        model: "FaixaDuration",
    },
    {
        key: "Calc_GrupoAtivo",
        label: "Calc_GrupoAtivo",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterGrupoAtivoTable,
        app: CALCULO,
        model: "GrupoAtivo",
    },
    {
        key: "Calc_GrupoIndicador",
        label: "Calc_GrupoIndicador",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterGrupoIndicadorTable,
        app: CALCULO,
        model: "GrupoIndicador",
    },
    {
        key: "Calc_IDCurvas",
        label: "Calc_IDCurvas",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterIDCurvasTable,
        app: CALCULO,
        model: "Curvas",
    },
    {
        key: "Calc_MultiplicadorLiquidez",
        label: "Calc_MultiplicadorLiquidez",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterMultiplicadorLiquidezTable,
        app: CALCULO,
        model: "MultiplicadorLiquidez",
    },
    {
        key: "Calc_RegrasDurasOutliers",
        label: "Calc_RegrasDurasOutliers",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRegrasDurasOutliersTable,
        app: CALCULO,
        model: "RegrasDurasOutliers",
    },
    {
        key: "Calc_ScoreRating",
        label: "Calc_ScoreRating",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterScoreRatingTable,
        app: CALCULO,
        model: "ScoreRating",
    },
    {
        key: "Calc_Setorial",
        label: "Calc_Setorial",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterSetorialTable,
        app: CALCULO,
        model: "Setorial",
    },
    {
        key: "Calc_RegrasDurasVolatilidade",
        label: "Calc_RegrasDurasVolatilidade",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterRegrasDurasVolatilidadeTable,
        app: CALCULO,
        model: "RegrasDurasVolatilidade",
    },
    {
        key: "Calc_AliasIndicadores",
        label: "Calc_AliasIndicadores",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterAliasIndicadoresTable,
        app: CALCULO,
        model: "AliasIndicadores",
    },
    {
        key: "Calc_CriteriosLiquidez",
        label: "Calc_CriteriosLiquidez",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCriteriosLiquidezTable,
        app: CALCULO,
        model: "CriteriosLiquidez",
    },
    {
        key: "Calc_CurvasNSSInicial",
        label: "Calc_CurvasNSSInicial",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCurvasNssInical,
        app: CALCULO,
        model: "CurvasNSSInicial",
    },
    {
        key: "Calc_SpreadsIndicativosOverlay",
        label: "Calc_SpreadsIndicativosOverlay",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCalcSpreadsIndicativosOverlayTable,
        app: CALCULO,
        model: "SpreadsIndicativosOverlay",
    },
    {
        key: "Calc_SpreadsDevedorOverlay",
        label: "Calc_SpreadsDevedorOverlay",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCalcSpreadsDevedorOverlayTable,
        app: CALCULO,
        model: "SpreadsDevedorOverlay",
    },
    {
        key: "Calc_SpreadsSecPulverizadoOverlay",
        label: "Calc_SpreadsSecPulverizadoOverlay",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCalcSpreadsSecPulverizadoOverlayTable,
        app: CALCULO,
        model: "SpreadsSecPulverizadoOverlay",
    },
    {
        key: "Calc_EventosCreditoClassificacao",
        label: "Calc_EventosCreditoClassificacao",
        endpoint: DATALAKE_CONSULTA_DADOS_PATH,
        component: ParameterCalcEventosCreditoClassificacaoTable,
        app: CALCULO,
        model: "EventosCreditoClassificacao",
    }

]